import { FirebaseMessaging } from '@capacitor-firebase/messaging'
import { LocalNotifications, ActionPerformed as LocalActionPerformed, Channel } from '@capacitor/local-notifications'
import { store } from '../index'
import { push } from 'connected-react-router'
import { getCurrentRoute } from '../common/Routes/RouterSelector'
import { IGlobalState } from '../Root/store/appReducer'
import { isAndroid, isIOS, isNative } from '../common/helpers/isNative'
import api from './api.services'
import { appMetaData } from '../common/auth/authSagas'
import { SetUserDevice$Request, UserProfileDto } from './api.types'
import { Preferences } from '@capacitor/preferences'
import { call, select } from 'redux-saga/effects'
import { getUserDto } from '../common/auth/authSelectors'
import { getFullName } from '../common/helpers/translations'
import { StreamChat } from 'stream-chat'
import { Badge } from '@capawesome/capacitor-badge'
import { getWhoAmI } from '../common/auth/authActions'
//import { getChatClient, registerPushTokenForChat } from '../views/ChallengeChat/hooks/useInitChat'

export const askPushNotificationPermissions = async () => {
  let permStatus = await FirebaseMessaging.checkPermissions()
  console.log('setUpPushNotifications | ask permissions', permStatus.receive)

  if (permStatus.receive === 'prompt') {
    /*const { value } = await CapacitorDialog.confirm({
      title: t`Notifications`,
      message: t`Do you want to receive push notifications from YuMuuv app?`,
    })
    if (!value) return*/
    permStatus = await FirebaseMessaging.requestPermissions()
  }

  if (permStatus.receive !== 'granted') {
    console.log('setUpPushNotifications | User denied permissions!')
    throw new Error('User denied permissions!')
  }

  //await FirebaseMessaging.getToken()
}

/*const handleChatNotifications = async (token: string, oldPushToken: string | null) => {
  try {
    const globalState = store.getState() as any as IGlobalState
    const currentRoute = getCurrentRoute(globalState)
    const pathParts = currentRoute.pathname ? currentRoute.pathname.split('/') : []
    const isChallengePage = !!(pathParts[1] === 'challenges' && pathParts[3] && pathParts[3] != 'edit')
    if (!isChallengePage) {
      console.log('setUpPushNotifications | !isChallengePage')
      const user = globalState?.auth?.userDto
      if (!user.userId) {
        console.log('Could not get user data!')
      } else {
        // console.log(`user:  ${JSON.stringify(user)}`)
        const { userId, firstName, lastName, email } = user
        const name = getFullName(firstName, lastName, email)
        // console.log(`userId: ${userId} | name: ${name}`)

        const chatClient: StreamChat | undefined = await getChatClient(userId, name)
        if (chatClient) {
          console.log('setUpPushNotifications | registerPushTokenForChat')
          //await registerPushTokenForChat(chatClient, userId, token)

          chatClient.addDevice(token, 'firebase').then(async () => {
            // console.log('Add device success')
            await Preferences.set({ key: 'currentPushToken', value: token })
            if (oldPushToken !== null && oldPushToken !== token) {
              await chatClient.removeDevice(oldPushToken)
              // console.log('Removed old token')
            }
            await chatClient.disconnectUser()
          })
          console.log('setUpPushNotifications | chatClient.disconnectUser()')
        }
      }
    }
  } catch (e: any) {
    console.error('setUpPushNotifications | handleChatNotifications error: ', e)
  }
}*/

// TODO: Create and use Saga instead.
const handleNewPushNotificationToken = async (token: string) => {
  const { value: oldPushToken } = await Preferences.get({ key: 'currentPushToken' })

  const request = {
    ...appMetaData,
    token,
  }

  try {
    await api.users.setUserDevice(request as SetUserDevice$Request)
  } catch (e: any) {
    console.error('setUpPushNotifications | setUserDevice error: ', e)
  }

  // await handleChatNotifications(token, oldPushToken)

  try {
    if (oldPushToken == null || oldPushToken !== token) {
      await Preferences.set({ key: 'currentPushToken', value: token })

      if (oldPushToken !== null) {
        await api.users.removeUserDevice({ token: oldPushToken })
        console.log('setUpPushNotifications | removed old token', oldPushToken)
      }
    }
  } catch (e: any) {
    console.error('setUpPushNotifications | removeUserDevice error: ', e)
  }
}

const handleBadge = (data: any) => {
  // Android badge support is not good unfortunately...
  if (isIOS && data && (data['channel_id'] === 'announcement' || data['channel_id'] === 'notification')) {
    console.log('notificationReceived | configure badge')
    store.dispatch(getWhoAmI())
    try {
      Badge.increase().then()
    } catch (e: any) {
      console.error('increase badge failed: ', e)
    }
  }
}

export const setUpPushNotifications = async () => {
  await FirebaseMessaging.removeAllListeners()

  /*await FirebaseMessaging.addListener('tokenReceived', async (event) => {
    const token = event.token
    console.log('xxx | setUpPushNotifications | tokenReceived', token)

    await handleNewPushNotificationToken(token)
  })*/

  if (isAndroid) {
    // Create notification channels to have heads up notifications.
    await LocalNotifications.createChannel({
      id: 'announcement',
      name: 'Announcements',
      importance: 4,
      visibility: 1,
    })
    await LocalNotifications.createChannel({
      id: 'notification',
      name: 'Notifications',
      importance: 4,
      visibility: 1,
    })
    await LocalNotifications.createChannel({
      id: 'challenge', // or chat ?
      name: 'Chat',
      importance: 4,
      visibility: 1,
    })
  }

  await FirebaseMessaging.addListener('notificationReceived', async (event) => {
    const notification = event.notification
    console.log('[PN] Notification received: ' + JSON.stringify(notification))

    const data = notification?.data as any

    handleBadge(data)

    if (isAndroid) {
      if (data && data['channel_type'] === 'challenge') {
        const currentRoute = getCurrentRoute(store.getState() as any as IGlobalState)
        const pathParts = currentRoute && currentRoute.pathname ? currentRoute.pathname.split('/') : []
        // Don't display chat notification when already in that chat.
        if (pathParts[3] !== 'chat' || pathParts[2] !== data['channel_id']) {
          const { title, body, subtitle } = notification
          if (title) {
            await LocalNotifications.schedule({
              notifications: [
                {
                  id: Math.floor(Math.random() * 100001), //data['gcm.message_id'] ? parseInt(data['gcm.message_id']) : 1,
                  title,
                  subtitle: subtitle || '',
                  body: body ? body : '',
                  extra: {
                    channel_id: data['channel_id'],
                    channel_type: data['channel_type'],
                  },
                  // iOS
                  //actionTypeId: 'stream.chat',
                  threadIdentifier: data['channel_id'],
                  // Android
                  group: data['channel_id'],
                  channelId: 'challenge',
                },
              ],
            })
          }
        }
      }

      if (data && (data['channel_id'] === 'announcement' || data['channel_id'] === 'notification')) {
        const { title, body, id } = notification
        // Or "announcement"?{"notification_id":"f1e25db4-2c0d-4e2e-a454-5efd541e1341","category":"notification"}
        // {"id":"0:1733744400840342%476e84f4476e84f4","data":{"channel_id":"announcement","notification_id":"76d42bef-2028-4072-8c31-2fb22ebd96ea","category":"announcement"},"title":"Android test","body":"123"}
        const channelId = data['channel_id']
        await LocalNotifications.schedule({
          notifications: [
            {
              id: Math.floor(Math.random() * 100001),
              title: title ? title : '',
              subtitle: '',
              body: body ? body : '',
              extra: {
                channel_id: channelId,
                channel_type: channelId,
                notification_id: data['notification_id'],
              },
              channelId,
            },
          ],
        })
      }
    }
  })

  await FirebaseMessaging.addListener('notificationActionPerformed', (event) => {
    // console.log('[PN] Push action performed: ' + JSON.stringify(event))

    const notification = event.notification
    const data = notification?.data as any

    // CHALLENGE CHAT.
    if (data && data['channel_type'] && data['channel_id']) {
      const goalId = data['channel_id']
      console.log(`Redirecting to ${goalId} chat`)
      store.dispatch(push(`/challenges/${goalId}/chat`))
    }

    // TODO: Announcements/Notifications.
    if (
      data &&
      (data['channel_id'] === 'announcement' || data['channel_id'] === 'notification') &&
      data['notification_id']
    ) {
      const notificationId = data['notification_id']
      console.log(`Redirecting notification: ${notificationId}`)
      store.dispatch(push(`/inbox/${notificationId}?isPush=isPush`))
    }
  })

  await LocalNotifications.addListener(
    'localNotificationActionPerformed',
    (notificationAction: LocalActionPerformed) => {
      console.log('[LN] Local action performed: ' + JSON.stringify(notificationAction))

      if (notificationAction.actionId === 'tap') {
        if (
          notificationAction &&
          notificationAction.notification &&
          notificationAction.notification.extra &&
          notificationAction.notification.extra['channel_type']
        ) {
          if (
            notificationAction.notification.extra['channel_type'] === 'challenge' &&
            notificationAction.notification.extra['channel_id']
          ) {
            const goalId = notificationAction.notification.extra['channel_id']
            console.log(`Redirecting to ${goalId} chat`)
            store.dispatch(push(`/challenges/${goalId}/chat`))
          }
          if (
            (notificationAction.notification.extra['channel_type'] === 'announcement' ||
              notificationAction.notification.extra['channel_type'] === 'notification') &&
            notificationAction.notification.extra['notification_id']
          ) {
            const notificationId = notificationAction.notification.extra['notification_id']
            console.log(`Redirecting notification: ${notificationId}`)
            store.dispatch(push(`/inbox/${notificationId}?isPush=isPush`))
          }
        }
      }
    },
  )

  const tokenResult = await FirebaseMessaging.getToken()
  if (tokenResult.token) await handleNewPushNotificationToken(tokenResult.token)
}
